import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import ResizeObserver from "resize-observer-polyfill";

if (!window.ResizeObserver) {
  window.ResizeObserver = ResizeObserver;
}

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <App />
);

// Optional
reportWebVitals();